import { render } from "./HomeWhyMe.vue?vue&type=template&id=5c600df3&scoped=true"
const script = {}

import "./HomeWhyMe.vue?vue&type=style&index=0&id=5c600df3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c600df3"]])

export default __exports__